module.exports = __webpack_public_path__ + "img/loading_stream.629206da.jpg";